import { memo } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { AppState } from 'services/types';
import {
    VirtualizedTableItemValue,
    VirtualizedTableProps
} from 'services/virtualizedTable/types';
import { makeSelectVirtualizedTableItemValueOptionsText } from 'services/virtualizedTable/selectors';

type OwnProps = VirtualizedTableProps;

export interface ConnectedProps {
    optionsText?: string | undefined;
}

export type Props = OwnProps & ConnectedProps;

export const VirtualizedTableColumnOptionsTextComponent = (
    props: Props
): VirtualizedTableItemValue | null => {
    const { optionsText } = props;

    if (optionsText) {
        return optionsText;
    }

    return null;
};

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    optionsText: makeSelectVirtualizedTableItemValueOptionsText()
});

export default connect(mapStateToProps)(
    memo(VirtualizedTableColumnOptionsTextComponent)
);
